import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";

const previewStyle = {
  width: 96,
  height: 96,
  objectFit: "cover",
  borderRadius: 4,
};

export default function ImageDropzone({ onChange }) {
  const [files, setFiles] = useState([]);
  const filesRef = useRef(files);
  const { getInputProps, getRootProps } = useDropzone({
    accept: { "image/*": [] },
    onDrop: (acceptedFiles) => {
      const nextFiles = acceptedFiles.map((file) =>
        Object.assign(file, { preview: URL.createObjectURL(file) }),
      );
      filesRef.current.forEach((file) => URL.revokeObjectURL(file.preview));
      filesRef.current = nextFiles;
      setFiles(nextFiles);
      onChange(nextFiles);
    },
  });

  useEffect(() => {
    return () =>
      filesRef.current.forEach((file) => URL.revokeObjectURL(file.preview));
  }, []);

  const removeFile = (fileToRemove) => {
    URL.revokeObjectURL(fileToRemove.preview);
    const nextFiles = files.filter((file) => file !== fileToRemove);
    filesRef.current = nextFiles;
    setFiles(nextFiles);
    onChange(nextFiles);
  };

  return (
    <div>
      <div {...getRootProps()} className="dropzone">
        <input {...getInputProps()} />
        <p>برای انتخاب تصویر کلیک کنید یا تصویر را اینجا رها کنید</p>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {files.map((file) => (
          <div key={`${file.name}-${file.lastModified}`}>
            <img src={file.preview} alt={file.name} style={previewStyle} />
            <button type="button" onClick={() => removeFile(file)}>
              حذف
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
